import type { DisciplineAllocationTutor } from './interfaces'

import { useAdminRoutes } from '@shared/lib/routes'

import { useDisciplineScheduleStore } from './schedule/store'
import {
  findAllocationTutor,
  formatScheduleDay,
  getAllocationTutorName,
} from './discipline-schedule'

interface DisciplineScheduleChosenTutorReturn {
  refTutor: ComputedRef<DisciplineAllocationTutor | null>
  refTutorName: ComputedRef<string>
  refTutorUrl: ComputedRef<string | null>
  refSlots: ComputedRef<string[]>
}

/** The tutor and slot pair picked in the run's results, as the confirmation modals show them. */
export const useDisciplineScheduleChosenTutor = (): DisciplineScheduleChosenTutorReturn => {
  const store = useDisciplineScheduleStore()

  const refTutor = computed<DisciplineAllocationTutor | null>(() => {
    const log = store.getChosenLog
    return log ? findAllocationTutor(log, store.getAllocationTutors) : null
  })

  const refTutorName = computed<string>(() => getAllocationTutorName(refTutor.value))

  const refTutorUrl = computed<string | null>(() =>
    (refTutor.value ? useAdminRoutes('admin.tutor.show', { tutor_id: refTutor.value.id }) : null))

  const refSlots = computed<string[]>(() => store.getChosenSlots.map(formatScheduleDay))

  return {
    refTutor,
    refTutorName,
    refTutorUrl,
    refSlots,
  }
}
